import LiveEventsBanner from './LiveEventsBanner';

export default LiveEventsBanner;
